import { useMutation, useQuery } from "@tanstack/react-query";

const API_BASE = import.meta.env.VITE_API_URL ?? "/api";

interface Testimonial {
  id: string;
  name: string;
  message: string;
  createdAt: string;
}

export function useTestimonials() {
  return useQuery<Testimonial[]>({
    queryKey: ["testimonials"],
    queryFn: async () => {
      const res = await fetch(`${API_BASE}/testimonials`);
      if (!res.ok) return [];
      return res.json();
    },
  });
}

export function useSubmitTestimonial() {
  return useMutation({
    mutationFn: async (payload: { name: string; message: string }) => {
      const res = await fetch(`${API_BASE}/testimonials`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const error = await res.json().catch(() => ({ error: "Erreur" }));
        throw new Error(error.error ?? "Erreur");
      }
      return res.json();
    },
  });
}
